import React from "react";
import { Link } from "react-router-dom";
import { appLoginPath, LANDING_PATHS } from "@/lib/landingPaths";
import SiteLogo from "@/components/SiteLogo";
import { getSiteBrand } from "@/lib/siteHosts";

const PartnerFooter = () => (
  <footer className="py-12 border-t border-partner" data-testid="partner-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <Link to={LANDING_PATHS.partner} className="flex items-center">
          <SiteLogo className="w-full max-w-[100px]" />
        </Link>

        <div className="flex flex-wrap justify-center gap-8 text-partner-muted text-sm">
          <Link
            to={LANDING_PATHS.roofing}
            className="hover:text-partner transition-colors"
          >
            Roofing Interceptor
          </Link>
          <Link
            to={LANDING_PATHS.realEstate}
            className="hover:text-partner transition-colors"
          >
            AI Broker
          </Link>
          <Link to={appLoginPath()} className="hover:text-partner transition-colors">
            Partner Login
          </Link>
        </div>

        <p className="text-partner-muted text-sm font-mono">
          © {new Date().getFullYear()} {getSiteBrand().name}
        </p>
      </div>
    </div>
  </footer>
);

export default PartnerFooter;
